export default {
  BusinessReportStockOut: {
    // querySpu: '商品名称/编码',
    stockoutOrderQty: '缺货订单数',
    stockoutGoodsQty: '缺货商品数',
    usableQty: '可移仓数量'
  }
};
